import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Checkbox } from "primeng/checkbox";
import { ReportParameterBase } from './report-parameter-base';

@Component({
    selector: 'app-checkbox-parameter',
    imports: [Checkbox, FormsModule],
    template: `
        <p-checkbox 
            [ngModel]="checked()"
            [id]="parameterKey()"
            [binary]="true"
            [disabled]="isDisabled()"
            [invalid]="isInvalid()"

            (ngModelChange)="onCheckedChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CheckboxParameterComponent,
            multi: true
        }
    ]
})
export class CheckboxParameterComponent extends ReportParameterBase<boolean> {
    checked = signal<boolean>(false);  

    onCheckedChange(checked: boolean) {
        this.checked.set(checked);

        this.reportWorkspace.setParam(this.parameterKey(), checked);

        this.onChange(checked);
        this.markTouchedIfNotResetting();
    }

    // CVA callbacks
    writeValue(obj: boolean): void {
        this.checked.set(obj ?? false);
    }
}
